import { Enrollment } from "./enrollment.interface";
import { Program } from "./programs.interface";

export enum ParticipantStatus {
  PENDING_VERIFICATION = "PENDING_VERIFICATION",
  ACTIVE = "ACTIVE",
}

export enum MobileUserStatusEnum {
  PENDING_VERIFICATION = "PENDING_VERIFICATION",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export interface TermCondition {
  accepted: boolean;
  termId: string;
  executionDate: string;
  revision: string;
}

export interface Invitation {
  invitationDate: string;
  code: string;
  status: string;
}

export interface MobileUser {
  status: string;
  authenticationId: string;
  lastLoginDate: Date;
}

export interface Officer {
  id: string;
  name: string;
}

export interface Participant {
  _id: string;
  isDeleted: boolean;
  createdBy: string;
  updatedBy: string;
  accountId: string;
  firstName: string;
  lastName: string;
  countryPhoneCode: string;
  phoneNumber: string;
  cin: string;
  email: string;
  dateOfBirth?: Date;
  status: ParticipantStatus;
  termConditions: TermCondition[];
  createdAt: string;
  updatedAt: string;
  invitations: Invitation;
  mobileUser: MobileUser;
  address: ParticipantAddress;
  totalIncentivesEarned?: number;
  currentYearIncentives?: string;
  currentYearIncentivesAmount?: number;
  totalBankBalance?: number;
  hasMultipleActiveEnrollments?: boolean;
  reachedMaximumYearlyEarnings?: boolean;
  totalActiveEnrollments?: number;
  totalCompletedEnrollments?: number;
  totalDisenrolledEnrollments?: number;
  canDelete?: boolean;
  totalIncentivesEarnedInActivePrograms?: number;
  fullName: string;
  maxEarnings?: number;
}

export interface ParticipantResponse {
  participant: Participant;
  lastEnrollment: Enrollment;
  program: Program;
}

export interface ParticipantAddress {
  house: string;
  locality: string;
  postalCode: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  county?: string;
  latitude?: number | null;
  longitude?: number | null;
  addressSynced?: boolean;
  // Secondary address
  secondaryAddressLine1?: string;
  secondaryAddressLine2?: string;
  secondaryCity?: string;
  secondaryState?: string;
  secondaryZipCode?: string;
  secondaryCounty?: string;
  secondaryLatitude?: number | null;
  secondaryLongitude?: number | null;
}

export type GeocodeErrorCode = "NOT_FOUND" | "LOOKUP_UNAVAILABLE";

export type ParticipantSaveResponse = Participant & {
  geocodedPrimary?: boolean;
  geocodedSecondary?: boolean;
  geocodePrimaryError?: GeocodeErrorCode;
  geocodeSecondaryError?: GeocodeErrorCode;
};

export interface ParticipantPayload {
  firstName: string;
  lastName: string;
  countryPhoneCode: string;
  phoneNumber: string;
  email: string;
  cin: string;
  dateOfBirth?: Date | null;
  address: ParticipantAddress;
}

export type ParticipantCreatePayload = ParticipantPayload & {
  createdBy: string;
};

export type ParticipantUpdatePayload = ParticipantPayload & {
  updatedBy: string;
  mobileStatus?: MobileUserStatusEnum;
};

export type ProgramOrgUnits = {
  programId: string;
  programName: string;
  orgUnits: {
    orgUnitId: string;
    orgUnitName: string;
  }[];
};

export type SearchParticipantsPayload = {
  sortField?: string | null;
  sortOrder?: string | null;
  pageNumber?: number;
  pageSize?: number;
  search?: string | null;
  status?: string[];
  programIds?: string[];
  orgUnitId?: string | null;
  groupLabelId?: string | null;
  notEnrolled?: boolean | null;
};

export interface ParticipantListItem {
  id: string;
  firstName: string;
  lastName: string;
  cmStartDate?: string;
  registrationStage?: string;
  firstValidation?: string;
  status: ParticipantStatus;
}

export interface SearchParticipantsResponse {
  participants: ParticipantListItem[];
  totalCount: number;
}
